
const fetchBanner = (vm) => {
  return new Promise(resolve => {
    vm.$http('get', '/api/baseBanner/list').then(res => {
      if (res.errCode === 0) {
        let list = res.data
        sessionStorage.setItem('BANNERLIST', JSON.stringify(list))
        resolve(list)
      }
    })
  })
}

// 获取banner列表
export const getBanner = async vm => {
  let bannerList = sessionStorage.getItem('BANNERLIST')
  if (bannerList) {
    bannerList = JSON.parse(bannerList)
    return Promise.resolve(bannerList)
  } else {
    let data = await fetchBanner(vm)
    return data
  }
}


// 下载 列表
export const getFileInfoPage = function (params) {
  return this.$http('get', '/fileInfo/page', params);
}

// 更新下载次数
export const fileInfoDownload = function (id) {
  return this.$http('post', '/fileInfo/download?id=' + id)
}
